import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useSession } from 'src/contexts/SessionContext';
import { useCable } from 'src/shared/useCable';

import {
  STAFF_TASKS_QUERY_KEY,
  fetchIncompleteStaffTaskCount,
  incompleteStaffTaskCountQueryKey,
} from './task';

export const useIncompleteTaskCount = () => {
  const { user } = useSession();
  const queryClient = useQueryClient();
  const cable = useCable();

  const query = useQuery({
    queryKey: incompleteStaffTaskCountQueryKey(user.id),
    queryFn: fetchIncompleteStaffTaskCount,
    enabled: !!user.id,
    staleTime: 1000 * 60,
  });

  useEffect(() => {
    if (!cable || !user.id) return;

    const subscription = cable.subscriptions.create(
      {
        channel: 'StaffTasksChannel',
        user_id: user.id,
      },
      {
        received: () => {
          queryClient.invalidateQueries({
            queryKey: [STAFF_TASKS_QUERY_KEY],
          });
        },
      }
    );

    return () => {
      subscription.unsubscribe();
    };
  }, [cable, user.id, queryClient]);

  return query;
};
